import { Injectable } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { StoreService } from '@root/shared/service/store.service';
import { HouseOrderDetailComponent } from '@root/router/component/house-order-detail/house-order-detail.component';
import { SynTaskListComponent } from '@root/router/component/syn-task-list/syn-task-list.component';
import {
  TujiaAutoReceiptComponent,
  key,
} from '@root/component/tujia-auto-receipt/tujia-auto-receipt.component';
import { InviteComponent } from '@root/component/invite/invite.component';
import { ImageMagnifierService } from '@root/component/image-magnifier/image-magnifier.service';
import { ClientComponent } from '../component/customer-service/client/client.component';
import {
  ZhenguoSyncMessageComponent,
  key as zhenguoKey,
} from '@root/component/zhenguo-sync-message/zhenguo-sync-message.component';
import { TranslateService } from '@root/shared/service/translate.service';
import { QrcodeDownloadComponent } from '@root/component/qrcode-download/qrcode-download.component';
import { CouponListComponent } from '@root/component/coupon-list/coupon-list.component';
import { SystemNotificationComponent } from '@root/component/system-notification/system-notification.component';
import { AuditDetailsComponent } from '@root/router/properties/audit-details/audit-details.component';
import { FailHousesComponent } from '@root/router/properties/fail-houses/fail-houses.component';
import { DuplicateGuestComponent } from '../component/guest/duplicate-guest/duplicate-guest.component';
import { EditGuestComponent } from '../component/guest/edit-guest/edit-guest.component';
import { EditRateComponent } from '@root/router/component/rate/edit-rate/edit-rate.component';
import {
  CreateTaskComponent,
  ITaskDetail,
} from '@root/router/component/task/create-task/create-task.component';
import { DepositComponent } from '../component/deposit/deposit.component';
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private customerServiceClientRef: NzModalRef;
  private notificationRef: NzModalRef;

  constructor(
    private modalService: NzModalService,
    private storeService: StoreService,
    private imageMagnifierService: ImageMagnifierService,
    private translateService: TranslateService
  ) {
  }

  displayReservationDetail(params) {
    this.modalService.create({
      // 订单详情
      nzTitle: this.translateService.syncGet('word.order_detail'),
      nzContent: HouseOrderDetailComponent,
      nzFooter: null,
      nzWidth: 900,
      nzComponentParams: {
        pageType: 'modal',
        ...params,
      },
    });
  }

  displayTaskList(params) {
    this.modalService.create({
      // 同步任务列表
      nzTitle: this.translateService.syncGet('index.sync_task_list'),
      nzContent: SynTaskListComponent,
      nzWidth: 690,
      nzFooter: null,
      nzComponentParams: params,
    });
  }

  displayAuditDetail(params) {
    const modal = this.modalService.create({
      // 审核详情
      nzTitle: this.translateService.syncGet('house.airbnb_check_detail'),
      nzContent: AuditDetailsComponent,
      nzFooter: null,
      nzWidth: '653px',
      nzComponentParams: params,
    });
    modal.afterClose.subscribe((res) => {
      if (res === 'openFailList') {
        this.displayAuditFailedHouseList();
      }
    });
  }

  displayAuditFailedHouseList() {
    const modal = this.modalService.create({
      // 爱彼迎直连审核失败房源
      nzTitle: this.translateService.syncGet('house.airbnb_fail_list'),
      nzContent: FailHousesComponent,
      nzFooter: null,
      nzWidth: '653px',
    });
    modal.afterClose.subscribe((res) => {
      if (res && res.title === 'openAuditDetail') {
        this.displayAuditDetail({ code: res.house.origin_house_id });
      }
    });
  }

  displayTujiaAutoReceiptModal(code?: string) {
    const tujiaReservationPrefix = '1-';

    if (code && !code.startsWith(tujiaReservationPrefix)) {
      return;
    }

    const forbideAlert = !!this.storeService.get(key, 2);
    if (forbideAlert) {
      return;
    }

    this.modalService.create({
      nzTitle: null,
      nzContent: TujiaAutoReceiptComponent,
      nzFooter: null,
      nzWidth: 420,
      nzClosable: false,
    });
  }

  displayZhenguoSyncMessageModal() {
    const forbideAlert = !!this.storeService.get(zhenguoKey, 2);
    if (forbideAlert) {
      return;
    }
    this.modalService.create({
      nzTitle: null,
      nzContent: ZhenguoSyncMessageComponent,
      nzFooter: null,
      nzWidth: 420,
      nzClosable: false,
    });
  }

  displayInviteModal() {
    this.modalService.create({
      nzTitle: '我的邀请',
      nzContent: InviteComponent,
      nzFooter: null,
      nzWidth: 480,
    });
  }

  // displayCustomerServiceModal() {
  //   this.modalService.create({
  //     nzTitle: null,
  //     nzContent: CustomerServiceComponent,
  //     nzWidth: 380,
  //     nzFooter: null,
  //     nzWrapClassName: 'host-pay-invite-service-modal',
  //   });
  // }

  displayImageMagnifier(url) {
    this.imageMagnifierService.open(url);
  }

  displayAppDownloadModal() {
    this.modalService.create({
      nzTitle: null,
      nzContent: QrcodeDownloadComponent,
      nzWidth: 335,
      nzFooter: null,
      nzClosable: false,
      nzBodyStyle: {
        padding: '0',
      },
    });
  }

  displayCouponListModal(params?) {
    return this.modalService.create({
      nzTitle: this.translateService.syncGet('modal.coupon.list.title'),
      nzContent: CouponListComponent,
      nzFooter: null,
      nzWidth: 480,
      nzBodyStyle: {
        padding: '0',
      },
      nzComponentParams: params,
    });
  }

  displaySystemNotificationModal(data) {
    if (this.notificationRef) {
      return;
    }
    this.notificationRef = this.modalService.create({
      nzTitle: null,
      nzContent: SystemNotificationComponent,
      nzFooter: null,
      nzBodyStyle: {
        padding: '0',
      },
      nzComponentParams: { notification: data },
    });

    this.notificationRef.afterClose.subscribe(
      (res) => (this.notificationRef = null)
    );
  }

  displayCustomerServiceClient(params?) {
    if (this.customerServiceClientRef) {
      return this.customerServiceClientRef;
    }
    this.customerServiceClientRef = this.modalService.create({
      nzTitle: null,
      nzContent: ClientComponent,
      nzWidth: 400,
      nzFooter: null,
      nzMask: true,
      nzMaskClosable: false,
      nzClosable: false,
      nzWrapClassName: 'host-customer-service-client-modal',
      nzComponentParams: { entry: 'web-客服', ...params },
    });
    this.customerServiceClientRef.afterClose.subscribe((res) => {
      this.customerServiceClientRef = null;
    });

    return this.customerServiceClientRef;
  }

  isCustomerServiceClientOpen() {
    return !!this.customerServiceClientRef;
  }

  displayDuplicateGuestModal(params?) {
    return this.modalService.create({
      // nzTitle: '添加房客',
      nzTitle: this.translateService.syncGet('modal.title.add_guest'),
      nzWidth: 820,
      nzContent: DuplicateGuestComponent,
      nzComponentParams: params,
      nzFooter: null,
    });
  }

  displayCreateGuestModal(guestInfo?) {
    return this.modalService.create({
      // nzTitle: '添加新房客',
      nzTitle: this.translateService.syncGet('modal.title.add_new_guest'),
      nzWidth: 800,
      nzContent: EditGuestComponent,
      nzComponentParams: { type: 'create', guestInfo },
      nzFooter: null,
    });
  }

  displayUpdateGuestModal(guestInfo?) {
    return this.modalService.create({
      // nzTitle: '编辑房客',
      nzTitle: this.translateService.syncGet('modal.title.edit_guest'),
      nzWidth: 800,
      nzContent: EditGuestComponent,
      nzComponentParams: { type: 'update', guestInfo },
      nzFooter: null,
    });
  }

  displayRateModal(params?) {
    return this.modalService.create({
      nzTitle: this.translateService.syncGet('rate.word.rate'),
      nzWidth: 680,
      nzContent: EditRateComponent,
      nzFooter: null,
      nzComponentParams: params,
    });
  }

  displayRateReplyModal(params?) {
    return this.modalService.create({
      nzTitle: this.translateService.syncGet('rate.word.reply'),
      nzWidth: 680,
      nzContent: EditRateComponent,
      nzFooter: null,
      nzComponentParams: {
        pageType: 'reply',
        ...params,
      },
    });
  }

  displayCreateTaskModal(data?: ITaskDetail) {
    return this.modalService.create({
      nzTitle: data && data.id ? '修改任务' : '创建任务',
      nzWidth: 800,
      nzContent: CreateTaskComponent,
      nzFooter: null,
      nzComponentParams: {
        data: data,
      },
    });
  }

  displayDepositModal () {
    return this.modalService.create({
      nzTitle: '押金',
      nzWidth: 850,
      nzContent: DepositComponent,
      nzFooter: null
    });
  }

  destroy() {
    this.customerServiceClientRef && this.customerServiceClientRef.destroy();
  }
}
